import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/View/Login.vue"),
  },
  {
    path: "/",
    redirect: { name: "Home" },
  },
  {
    path: "/",
    name: "Framework",
    component: () => import("@/View/Framework.vue"),
    children: [
      {
        path: "/home",
        name: "Home",
        component: () => import("@/View/Home.vue"),
      },
      {
        path: "/area",
        name: "Area",
        component: () => import("@/View/Area.vue"),
      },
      {
        path: "/city",
        name: "City",
        component: () => import("@/View/City.vue"),
      },
      {
        path: "/project",
        name: "Project",
        component: () => import("@/View/Project.vue"),
      },
      {
        path: "/park",
        name: "Park",
        component: () => import("@/View/Park.vue"),
      },
      {
        path: "/ti",
        name: "Ti",
        component: () => import("@/View/Ti.vue"),
        props: (route) => {
          return {
            parkId: route.query.parkId,
          };
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const originalReplace = router.push;

router.push = async function push(location) {
  try {
    return await originalReplace.call(this, location);
  } catch (e) {
    if (
      !e.message.startsWith("Avoided redundant navigation to current location:")
    ) {
      throw e;
    }
  }
};
router.replace = async function replace(location) {
  try {
    return await originalReplace.call(this, location);
  } catch (e) {
    if (
      !e.message.startsWith("Avoided redundant navigation to current location:")
    ) {
      throw e;
    }
  }
};

export default router;
